var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.2 21.85-1.5-2a.377.377 0 0 0-.21-.1H8c-4.17 0-6.75-1.13-6.75-6.75V8c0-4.42 2.33-6.75 6.75-6.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H8C4.42 2.75 2.75 4.42 2.75 8v5c0 4.52 1.55 5.25 5.25 5.25h.5c.51 0 1.09.29 1.4.7l1.5 2c.35.46.85.46 1.2 0l1.5-2c.33-.44.85-.7 1.4-.7h.5c3.58 0 5.25-1.67 5.25-5.25V8c0-.41.34-.75.75-.75s.75.34.75.75v5c0 4.42-2.33 6.75-6.75 6.75h-.5c-.08 0-.15.04-.2.1l-1.5 2c-.46.61-1.11.96-1.8.96s-1.34-.35-1.8-.96z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM15 11c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1zM7 11c0-.55.45-1 1-1s1 .45 1 1-.44 1-1 1-1-.45-1-1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49 4.86c-.25-.74-.19-1.59.16-2.26.31-.6.83-1.04 1.47-1.24.65-.2 1.34-.11 1.88.22.54-.33 1.23-.42 1.89-.22.64.2 1.16.64 1.47 1.24.35.67.41 1.52.16 2.26-.63 1.9-2.75 2.89-3.52 2.89-.86 0-2.89-1.02-3.51-2.89zm3.53 1.39c.29-.03 1.69-.68 2.08-1.86.12-.36.09-.79-.07-1.1a.939.939 0 0 0-.58-.49c-.28-.1-.66-.05-.83.2-.14.2-.36.32-.6.33-.24 0-.47-.11-.62-.3-.21-.27-.58-.31-.85-.23-.26.08-.45.24-.58.49-.15.31-.18.73-.06 1.09.42 1.26 1.85 1.84 2.11 1.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageFavorite);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-favorite.68f81359b26cced8447c22350573fe09.svg";
export { ForwardRef as ReactComponent };